module.exports = __webpack_public_path__ + "img/pic-silverlight-logo@2x.2f825e64.png";